import React from 'react';
import { useParams } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import { AppStoreHomeProvider } from '../../features/apps/context/AppStoreHomeContext';
import NotesPage from '../../features/notes/components/NotesPage';

export default function NotesRoute() {
  const { id: appId } = useParams();
  return (
    <ProtectedRoute>
      <AppStoreHomeProvider>
        <NotesPage />
      </AppStoreHomeProvider>
    </ProtectedRoute>
  );
}
